import React, { Fragment, useState, useEffect } from 'react'
import './AssignAgentPane.scss'
import '../../../../stylesheets/custom_scrollbar.scss'
import ContentPlain from '../../../../components/layout/ContentPlain'
import SearchBar from '../../../../components/search/SearchBar'
import HrbTranslate from '../../../../components/language/HrbTranslate'
import AgentListRow from './AgentListRow'
import AgentListSortHeader from './AgentListSortHeader'
import Button from '../../../../components/library/buttons/Button'
import ticketService from '../../services/manage/TicketService'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import AssignErrorModal from './AssignErrorModal'
import TicketActions from '../../../../store/ticketRedux'
import { hasValue, scrollToTop } from '../../../../services/util/CommonUtil'
import useAssociateSearch from '../../../associates/hooks/useAssociateSearch'

const AssignAgentPane = (props) => {

    const { isClosedTicket, officeId, associateId } = props

    const { setSearch, setSort, setSelected, searching, agentList, selectedAgent, selectedAgentOffice, searchString, sortBy, isReversed } = useAssociateSearch()

    const dispatch = useDispatch();

    const { id: ticketId } = useSelector(state => state.tickets.selectedTicket, shallowEqual)
    const myEmployeeId = useSelector(state => state.accountData.employeeId)

    const [assigning, setAssigning] = useState(false)
    const [showError, setShowError] = useState(false)

    const assignAssociate = async (associate, associateOffice, openTicket) => {
        if (!assigning) {
            try {
                setAssigning(true)

                if (!associate) {
                    setShowError(true)
                } else {
                    let result = null;

                    if (openTicket) {
                        await ticketService.openAndAssignTicket(ticketId, associateId);
                        result = await ticketService.assignTicket(ticketId, associate, associateOffice, false, true);
                    } else {
                        result = await ticketService.assignTicket(ticketId, associate, associateOffice, false, true);
                    }
                   
                    if (result) {
                        clearForm()
                        // scroll to top here to show newly assigned agent
                        scrollToTop()
                        // set selected ticket in redux store.
                        dispatch(TicketActions.setSelectedTicket(result))
                    } else {
                        setShowError(true)
                    }
                }
            } catch (ex) {
                setShowError(true)
            } finally {
                setAssigning(false)
            }
        }
    }

    const clearForm = () => {
        setSearch('')
        setSelected(null, null)
    }

    useEffect(() => {
        if (hasValue(officeId)) {
            setSearch(officeId)
        }
    }, [])

    return <ContentPlain elementId='assign-agent-pane' className='mt-6 mb-4'>
        <div className='columns px-3 mb-0'>
            <div className='agent-assignment card column is-10 is-offset-1 py-0 px-0'>
                <header id='agent-search' className='columns mx-0 my-0 py-0'>
                    <div className='column is-12'>
                        <SearchBar elementId='search-agents' placeholderKey='ManageTicket.SearchPlaceholder' performSearch={search => setSearch(search)} maxLength={100} defaultValue={searchString} showButton />
                    </div>
                </header>
                <AgentListSortHeader renderLinks={agentList.length > 0} sortKey={sortBy || 'name'} isReversed={isReversed} onSortChanged={setSort} />
                <div className='agent-list-scroll-container columns my-2 px-0 mx-2'>
                    <div id='agent-list' className='agent-list-container custom-scroll column is-12'>
                        {!searching && (!agentList || agentList.length === 0) &&
                            <div className='no-results'>
                                <HrbTranslate text='ManageTicket.NoResults' />
                            </div>
                        }
                        {!searching && (agentList && agentList.length > 0) &&
                            agentList.map(a =>
                                <AgentListRow
                                    key={`emp_${a.id}`}
                                    agent={a}
                                    isSelected={`${a.id}` === selectedAgent}
                                    onSelected={() => setSelected(a.id, a.officeId)}
                                />)
                        }
                        {searching &&
                            <Fragment>
                                <AgentListRow />
                                <AgentListRow />
                                <AgentListRow />
                                <AgentListRow />
                                <AgentListRow />
                            </Fragment>
                        }
                    </div>
                </div>
                <footer className='columns my-0 py-0'>
                    <div className='column is-6 is-offset-1'>
                        <a onClick={() => assignAssociate(myEmployeeId, null, isClosedTicket, false, true)}>
                            <HrbTranslate text={isClosedTicket ? 'ManageTicket.OpenAndAssignToMe' : 'ManageTicket.AssignToMe'} />
                        </a>
                    </div>
                    <div className='assign-button-container column is-4'>
                        <Button
                            elementId='btn-clear-form'
                            labelKey='ManageTicket.Clear'
                            buttonStyles='secondary'
                            disabled={!selectedAgent || assigning}
                            onClick={() => clearForm()} />
                        <Button
                            elementId='btn-assign'
                            labelKey={isClosedTicket ? 'ManageTicket.OpenAndAssign' : 'ManageTicket.Assign'}
                            buttonStyles='primary ml-3'
                            disabled={!selectedAgent}
                            onClick={() => assignAssociate(selectedAgent, selectedAgentOffice, isClosedTicket)}
                            loading={assigning} />
                    </div>
                </footer>
            </div>
        </div>
        <AssignErrorModal isOpen={showError} onClose={() => { setShowError(false) }} />
    </ContentPlain>
}

AssignAgentPane.whyDidYouRender = false

export default AssignAgentPane